import { api } from '../utils/request'

export const visaBooking = async (data) => {
    const resp = await api({
        endpoint: '/visaBooking',
        method: 'POST',
        data,
    })
    return resp
}

export const visaCountry = async () => {
    const resp = await api({
        endpoint: '/visaCountry',
        method: 'GET',

    })
    return resp
}